<script setup>
import FormContainer from "@/Pages/Components/FormContainer.vue";
import {watch} from "vue";

const { form } = defineProps({
    form: {
        type: Object,
        default: {}
    },
    showOtherUpdates: {
        type: Boolean,
        default: false,
    }
})

watch(
    () => form.contactAnyTime,
    () => {
        form.contactWeekdayAM = null
        form.contactWeekdayPM = null
        form.contactWeekendsAM = null
        form.contactWeekendsPM = null
    }
)

form.termsAndConditions = null
</script>

<template>
    <FormContainer title="Contacting you">
        <v-row>
            <v-col cols="12">
                <p>Please select times below that you ARE happy to be contacted at:</p>
            </v-col>
            <v-col cols="12">
                <v-row>
                    <v-col cols="auto">
                        <v-checkbox v-model="form.contactAnyTime" color="primary" label="Any time" value="any-time"/>
                    </v-col>
                    <v-col cols="auto" class="pr-3 pt-7">
                        <p>OR</p>
                    </v-col>
                    <v-col cols="6" class="pt-7">
                        <p>Weekdays:</p>
                        <v-checkbox :disabled="(form.contactAnyTime === 'any-time')" v-model="form.contactWeekdayAM" class="d-inline-block" color="primary" label="AM" value="weekday-am"/>
                        <v-checkbox :disabled="(form.contactAnyTime === 'any-time')" v-model="form.contactWeekdayPM" class="d-inline-block" color="primary" label="PM" value="weekday-pm"/>
                         <p>Weekends:</p>
                        <v-checkbox :disabled="(form.contactAnyTime === 'any-time')" v-model="form.contactWeekendsAM" class="d-inline-block" color="primary" label="AM" value="weekends-am"/>
                        <v-checkbox :disabled="(form.contactAnyTime === 'any-time')" v-model="form.contactWeekendsPM" class="d-inline-block" color="primary" label="PM" value="weekends-pm"/>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12">
                <v-checkbox v-model="form.termsAndConditions" color="primary" :error-messages="form.errors.termsAndConditions">
                    <template v-slot:label>
                        <span>
                            Do you agree to the<br> <a class="sw-hyperlink" href="https://www.fosterwithyourlocalcouncil.org.uk/terms-and-conditions" target="_blank">Terms and Conditions <v-icon size="12">far fa-arrow-up-right-from-square</v-icon> </a>?*
                        </span>
                    </template>
                </v-checkbox>
            </v-col>
            <v-col cols="12" v-if="showOtherUpdates">
                <v-checkbox
                    v-model="form.receiveOtherUpdates"
                    :value="true"
                    :error-messages="form.errors.receiveOtherUpdates"
                    label="Would you like to receive other updates from us?"
                />
            </v-col>
        </v-row>
    </FormContainer>
</template>

<style scoped>

</style>
